import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import DivContainerBody from "../../../../../components/DivContainerBody";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {AddIcon, CleanIcon} from "../../../../../components/buttons/IconButtons";
import {EmployeeFlowCreateOrderApp} from "../../../Supplier/Funtionality/SupplierCreateUpdateFlows/EmployeeFlowCreateOrderApp";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";
import React from "react";
import {EmployeeFlowOrderForm} from "./EmployeeFlowOrderForm";

export const EmployeeFlowCreateOrder = () => {

    const {
        CreateOrderHandler,
        handleClear,
        order,
        emptyFields,
        handleChange
    } = EmployeeFlowCreateOrderApp()

    return (
        <>
            <HeadTittle
                name={'create'}
                onBack={routes.suppliers.main}
                divStack={
                    <div className={"ml-1"}>
                        <ButtonIcon
                            id='btn_efc_clean'
                            Icon={CleanIcon}
                            onClick={handleClear}
                            title={'clear_instances'}
                            className={"btn-clean-secondary-600"}
                            tooltipPlacement={"right"}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    </div>
                }
            >
                <ButtonAction
                    id='btn_cts_create'
                    name='create'
                    className='btn-icon-add mr-2'
                    Icon={AddIcon}
                    onClick={CreateOrderHandler}
                />
            </HeadTittle>
            <DivContainerBody>
                <EmployeeFlowOrderForm
                    order={order}
                    emptyFields={emptyFields}
                    handleChange={handleChange}
                />
            </DivContainerBody>
        </>
    );
};
